<script>
//全局路径
const globalPath = {};
let path;


//获取各打包环境地址，并拼接
if (process.env.NODE_ENV === "development") {
    // dev
    path = {
        Sso:"/Sso/",
        IgwIar:"/IgwIar/"
    }
} else {
    path = {
        Sso : process.env.API_ROOT + 'sso/',
        IgwIar : process.env.API_ROOT + 'igw/iar/',
    }
    console.log('process.env.NODE_ENV：'+ process.env.NODE_ENV)
}

console.log(path)
Object.assign(globalPath, path);

export default {
    globalPath
};
</script>



// WEBPACK FOOTER //
// src/assets/script/globalPath.vue